'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQueryAbove } from '@svs/ui/media-query/react';
import { Button } from '@svs/ui/react/button';
import {} from 'react';
import { TipsenLink } from '../TipsenLink/entry.js';
/**
 * Component that uses mediaquery to determine which searchparam to apply.
 *
 * @param root0 input props
 * @param root0.children the children to pass down
 * @param root0.queryOnLargeScreen the query if screen is large
 * @param root0.queryOnSmallScreen the query if screen is small
 * @param root0.trackingAction the tracking action to track when the button is clicked
 * @returns Component that uses mediaquery to determine which searchparam to apply
 */
export default function OpenModalButton({ children, queryOnLargeScreen, queryOnSmallScreen, trackingAction, }) {
    const isLargeScreen = useMediaQueryAbove('md');
    const query = isLargeScreen ? queryOnLargeScreen : queryOnSmallScreen;
    return (_jsx(Button, { asChild: true, onClick: trackingAction ?? undefined, className: isLargeScreen ? undefined : 'w-full', variant: isLargeScreen ? 'outline' : 'ghost', size: isLargeScreen ? 'md' : 'sm', children: _jsx(TipsenLink, { href: {
                query: query,
            }, scroll: false, queriesToKeep: "ALL", children: children }) }));
}
//# sourceMappingURL=OpenModalButton.js.map